module.exports = __webpack_public_path__ + "static/media/no-image.faaf520f.jpg";